// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { endOfDecade as fn } from "../endOfDecade.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const endOfDecadeWithOptions = convertToFP(fn, 2);

// Fallback for modularized imports:
export default endOfDecadeWithOptions;
